import { render, staticRenderFns } from "./addOrUpdateReview.vue?vue&type=template&id=011316ca&scoped=true&"
import script from "./addOrUpdateReview.vue?vue&type=script&lang=js&"
export * from "./addOrUpdateReview.vue?vue&type=script&lang=js&"
import style0 from "./addOrUpdateReview.vue?vue&type=style&index=0&id=011316ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011316ca",
  null
  
)

export default component.exports